<script>
import ChallengeCard from './ChallengeCard'

export default {
  name: 'PageChallenges',

  components: {
    ChallengeCard
  },

  data() {
    return {
      challenges: null
    }
  },

  created() {
    this.Loading.yes = true

    this.axios.get('/challenges')
      .then(response => (this.challenges = response.data))
      .finally(() => (this.Loading.yes = false))
  }
}
</script>

<template>
  <section class="container">
    <challenge-card
      class="challenge"
      v-if="challenges"
      v-for="challenge in challenges"
      :key="challenge.id"
      :challenge="challenge"/>
  </section>
</template>

<style scoped>
.container {
  max-width: 640px;
}

.challenge {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/PageChallenges.vue